import * as d3 from 'd3';

/**
 * Создает проекцию для карты России
 * Использует коническую равновеликую проекцию Альберса (Albers Russia)
 *
 * @param {number} width - ширина SVG
 * @param {number} height - высота SVG
 * @returns {d3.GeoProjection} - проекция D3
 */
export function createRussiaProjection(width, height) {
  return d3.geoConicEqualArea()
    .parallels([50, 70])          // Параллели для России
    .rotate([-105, 0])            // Центрирование по долготе
    .center([0, 64])              // Центрирование по широте
    .scale(width * 0.8)           // Масштаб
    .translate([width / 2, height / 2]); // Центрирование на SVG
}

/**
 * Создает проекцию для федерального округа
 *
 * @param {string} districtId - ID федерального округа
 * @param {number} width - ширина SVG
 * @param {number} height - высота SVG
 * @returns {d3.GeoProjection} - проекция D3
 */
export function createDistrictProjection(districtId, width, height) {
  // TODO: Настроить проекции для каждого округа индивидуально
  // Пока используем базовую проекцию
  return createRussiaProjection(width, height);
}

/**
 * Создает проекцию для субъекта РФ
 *
 * @param {string} subjectId - ID субъекта
 * @param {number} width - ширина SVG
 * @param {number} height - высота SVG
 * @returns {d3.GeoProjection} - проекция D3
 */
export function createSubjectProjection(subjectId, width, height) {
  // TODO: Настроить проекции для каждого субъекта индивидуально
  return createRussiaProjection(width, height);
}

/**
 * Цветовая палитра для федеральных округов
 */
export const DISTRICT_COLORS = {
  'central': '#3498db',
  'northwestern': '#9b59b6',
  'southern': '#e74c3c',
  'north-caucasian': '#e67e22',
  'volga': '#2ecc71',
  'ural': '#f39c12',
  'siberian': '#1abc9c',
  'far-eastern': '#34495e'
};

/**
 * Полные названия федеральных округов
 */
export const DISTRICT_FULL_NAMES = {
  'central': 'Центральный федеральный округ',
  'northwestern': 'Северо-Западный федеральный округ',
  'southern': 'Южный федеральный округ',
  'north-caucasian': 'Северо-Кавказский федеральный округ',
  'volga': 'Приволжский федеральный округ',
  'ural': 'Уральский федеральный округ',
  'siberian': 'Сибирский федеральный округ',
  'far-eastern': 'Дальневосточный федеральный округ'
};

/**
 * Генерирует цвет для субъекта РФ (вариация от цвета округа)
 */
export function getSubjectColor(districtId, index) {
  const baseColor = DISTRICT_COLORS[districtId] || '#95a5a6';
  return d3.color(baseColor).brighter(index * 0.2).toString();
}
